import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// STATE AND STORE
// LIBS
import API from "../../../api";
import { fioLitleTruncateFromObject } from "../../../lib/helpers/strings";
import { getDateFormat } from "../../../lib/helpers/dates";
import {
  getFilialMoneyHistoryPrefix,
  getFilialMoneyStatusOperationWith
} from "../../../lib/helpers/filials";
import { sumFormat } from "../../../lib/helpers/strings";

// UI
import { Header, Table, Pagination } from "../../../ui";
import IconEdit from "../../../ui/src/ui/components/icons/edit";
import IconArrowUpLongBold from "../../../ui/src/ui/components/icons/arrowUpLongBold";
import IconArrowDownLongBold from "../../../ui/src/ui/components/icons/arrowDownLognBold";

export default class FilialMoney extends Component {
  static propTypes = {
    filialId: PropTypes.string.isRequired
  };

  state = {
    loading: true,
    money: {
      list: [],
      meta: {
        page: 0,
        pages: 0,
        count: 0,
        perPage: 0,
        fromRecord: 0,
        toRecord: 0
      }
    },
    query: {
      page: 0
    }
  };

  async componentDidMount() {
    const { filialId } = this.props;

    const { data: list, meta } = await API.filials.getMoneyOperations(
      filialId,
      this.state.query.page,
      { full: true }
    );

    this.setState({
      loading: false,
      money: {
        list,
        meta
      }
    });
  }

  onChangedPagination = async page => {
    const { filialId } = this.props;

    this.setState({
      loading: true
    });

    const { data: list, meta } = await API.filials.getMoneyOperations(
      filialId,
      page,
      {
        full: true
      }
    );

    this.setState({
      loading: false,
      money: {
        list,
        meta
      },
      query: {
        page
      }
    });
  };

  getTableColumns = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => this.state.money.meta.fromRecord + i
      },
      {
        title: "Дата",
        suffix: "операции",
        render: ({ item }) => getDateFormat(item.created_at)
      },
      {
        title: "Тип",
        suffix: "операции",
        render: ({ item }) => {
          const operationDocument = getFilialMoneyStatusOperationWith(item);

          if (operationDocument.document === "bilets") {
            return (
              <Link to={`/bilets/${operationDocument._id}`}>
                <IconArrowUpLongBold className="icon-td icon-error" />
                {operationDocument.title}
              </Link>
            );
          } else if (operationDocument.type === "remove") {
            return (
              <div>
                <IconArrowUpLongBold className="icon-td icon-error" />
                {operationDocument.title}
              </div>
            );
          } else {
            return (
              <div>
                <IconArrowDownLongBold className="icon-td icon-success-active" />
                {operationDocument.title}
              </div>
            );
          }
        }
      },
      {
        title: "Сумма",
        suffix: "в операции",
        text: "right",
        render: ({ item }) => {
          const operationDocument = getFilialMoneyStatusOperationWith(item);

          if (operationDocument.type === "remove") {
            return (
              <div className="color-error">
                {sumFormat(
                  item._options.sum,
                  null,
                  getFilialMoneyHistoryPrefix(item._options.type)
                )}
              </div>
            );
          } else {
            return (
              <div className="color-success-active">
                {sumFormat(
                  item._options.sum,
                  null,
                  getFilialMoneyHistoryPrefix(item._options.type)
                )}
              </div>
            );
          }
        }
      },
      {
        title: "Ответсвенный",
        suffix: "за операцию",
        render: ({ item }) => {
          return (
            <Link to={`/users/${item.user_id._id}`}>
              {fioLitleTruncateFromObject(item.user_id)}
            </Link>
          );
        }
      },
      {
        title: "",
        className: "icon",
        render: ({ item }) => {
          return (
            <Link to={`/filials/${this.props.filialId}/money/${item._id}/edit`}>
              <IconEdit />
            </Link>
          );
        }
      }
    ];
  };

  render() {
    return (
      <div>
        <Header size={4}>Операции с кассой</Header>

        <Table
          columns={this.getTableColumns()}
          data={this.state.money.list}
          loading={this.state.loading}
        />

        <Pagination
          linkPages={`/filials/${this.props.filialId}`}
          linkPagesQuery={false}
          count={this.state.money.meta.count}
          page={this.state.money.meta.page}
          pages={this.state.money.meta.pages}
          onClick={this.onChangedPagination}
        />
      </div>
    );
  }
}
